module.exports = __webpack_public_path__ + "img/MW-1440.1a055dbb.jpg";